export var PercentType;
(function (PercentType) {
    PercentType["fixed"] = "fixed";
    PercentType["individual"] = "fixed-individual";
    PercentType["progressive"] = "progressive";
})(PercentType || (PercentType = {}));
